export default {
    getCareers: {
        url: "/api/v1/jobs/list",
        method: "post"
    },
    getJobsList: {
        url: "/api/v1/jobs/list",
        method: "post"
    },
    getJobRoles: {
        url: "/api/v1/jobs/roles",
        method: "get"
    },
    getJobLocations: {
        url: "/api/v1/jobs/locations",
        method: "get"
    },
    getJobExperience: {
        url: "/api/v1/jobs/experience",
        method: "get"
    },
    getCareerById: {
        url: "/api/v2/career/{career_id}",
        method: "get"
    },
    createCareer: {
        url: "/api/v1/jobs/",
        method: "post"
    },
    updateCareer: {
        url: "/api/v1/jobs/{career_id}",
        method: "put"
    },
    patchCareerStatus: {
        url: "/api/v2/career/{career_id}/status",
        method: "patch"
    },
    deleteCareer: {
        url: "/api/v1/jobs/{career_id}",
        method: "delete"
    }
};
